export default __webpack_public_path__ + "static/media/slayer.b8052941.png";